import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, Subscription } from "rxjs";
import { IssueTransaction } from "../../../classes";
import { IssueTransactionService } from "../../../services/issue-transaction.service";

@Injectable()
export class IssueTransactionManagementComponentService {

    private _issueTransactions = new ReplaySubject<IssueTransaction[]>(1);
    issueTransactions$: Observable<IssueTransaction[]> = this._issueTransactions.asObservable();

    private _subscriptions: Subscription[] = [];

    constructor(private _issueTransactionService: IssueTransactionService){
        this.setUp();
    }

    dispose(){
        for(let sub of this._subscriptions) sub.unsubscribe();
        this._subscriptions = [];
    }

    setUp(){
        this._subscriptions.push(...[
            this._issueTransactionService.loadAllIssueTransactions(true).subscribe((issueTransactions: IssueTransaction[]) => {
                this._issueTransactions.next(issueTransactions);
            })
        ])
    }

}